import { runOnFeatureInit } from '@frontend/vanilla/core';

import { CookieInjectorBootstrapService } from './cookie-injector-bootstrap.service';

export function provide() {
    return [runOnFeatureInit(CookieInjectorBootstrapService)];
}
